import * as React from 'react';

const intersection = require('lodash.intersection');
const isEmpty = require('lodash.isempty');
const pick = require('lodash.pick');
const pickBy = require('lodash.pickby');
const map = require('lodash/map');
const flatten = require('lodash.flatten');

import { IBuildingTypesConfig, IBuildingTypesRow } from '../../../models/filters/building_types';
import { ISearchConfig } from '../../../models/search';

export const filterOptions = (
  searchType: string,
  buildingTypes: IBuildingTypesConfig,
  searchConfig: ISearchConfig,
): IBuildingTypesConfig  => {
  const keys = Object.keys(searchConfig[searchType]);

  return pickBy(map(buildingTypes, (option: IBuildingTypesRow, index: string) => {
    return {
      name: option.name,
      options: pick(option.options, keys),
    };
  }), (value: IBuildingTypesRow, key: string) => !isEmpty(value.options)) as IBuildingTypesConfig;
};

export const getSuitableBuildingType = (
  type: string,
  buildingType: string[],
  buildingTypes: IBuildingTypesConfig,
  searchConfig: ISearchConfig,
): string[] => {
  const filteredBuildingTypes = filterOptions(
    type,
    buildingTypes,
    searchConfig,
  );

  const selectedKeys = flatten(map(
    filteredBuildingTypes,
    (value: IBuildingTypesRow) => Object.keys(value.options),
  ));

  return intersection(selectedKeys, buildingType);
};

export function onInsideClick(fn: Function) {
  return (event: React.MouseEvent<any>) => {
    const currentTargetRect = (event.currentTarget as HTMLElement).getBoundingClientRect();
    const isInByY = event.clientY >= currentTargetRect.top
      && event.clientY <= currentTargetRect.top + currentTargetRect.height;
    const isInByX = event.clientX >= currentTargetRect.left
      && event.clientX <= currentTargetRect.left + currentTargetRect.width;

    if (!isInByX || !isInByY) {
      return;
    }

    fn();
  };
}
